import React from "react";
import "./components.css";
import portalBg from "../assets/portalBg.png";
import OrgCascader from "./updatedHome/components/OrgCascader";

function MinistryPicker() {
  return (
    <div className="ministryPicker-container">
      <div className="updatedHome-header-title">ТӨСВИЙН НЭГДСЭН СИСТЕМ</div>
      <OrgCascader />
      <div className="bg">
        <img
          style={{width: "100%", height: "100%", objectFit: "cover"}}
          alt="bg"
          src={portalBg}
        />
      </div>
    </div>
  );
}
export default MinistryPicker;
